import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import request from '@/services/request.service';
import { productActions } from '@/stores/action/home.action';
import { modalActions } from '@/stores/action/widget.action';
import Box from './Box';
import PopUp from './PopUp';
import { getLocaleWordContent } from '@/utils/language.util';

function Package({ show, total, ProductActions, ModalActions }) {
    const history = useHistory();
    const [qty, setQty] = useState(1);
    const [atc, setAtc] = useState(1);
    const [lst, setLst] = useState('');
    const [at, setAt] = useState('1');
    const [mess, setMess] = useState('');
    // const [active, setActive] = useState('');
    const getListProduct = async () => {
        const rsp = await request.post('/api/exchange/product_list.php').then((response) => response.data);

        if (rsp.result < 0) {
            window.alert(rsp.msg);
        } else {
            setLst(rsp.products);
            return rsp.products;
        }
    };
    const fetchBusinesses = () => {
        getListProduct();

        if (total !== '0') {
            console.log(total);
            setAtc(0);
        }
    };
    useEffect(fetchBusinesses, []);

    const changeQty = (e) => {
        if (e) e.preventDefault();
        if (e.target.name === 'qty') {
            setQty(e.target.value);
        }
    };

    const NextPage = (e, page) => {
        if (e) e.preventDefault();
        history.replace('/' + page);
    };

    return (
        <>
            {show.show && <PopUp message={mess} path={null} />}
            <div className="log_box">
                <div className="sp25"></div>
                <h2 className="strong">{getLocaleWordContent('상품')} {getLocaleWordContent('보유잔고')}</h2>

                <div className="lst_box">
                    {lst &&
                        lst?.map((it, index) => (
                            <Box
                                key={index}
                                num={index + 1}
                                it={it}
                                qty={qty}
                                atc={atc}
                                at={at}
                                setAt={setAt}
                                setAtc={setAtc}
                                setQty={setQty}
                                setMess={setMess}
                                changeQty={changeQty}
                                ProductActions={ProductActions}
                                ModalActions={ModalActions}
                            />
                        ))}
                </div>
                {/*  Purchase Reservation Details>   Product status > */}
                <div className="bottom-btn text-center">
                    <button className="b_orange btn02" onClick={(e) => NextPage(e, 'history')}>
                        {getLocaleWordContent('구매예약내역')} &gt;
                    </button>
                    <button className="b_orange btn02" onClick={(e) => NextPage(e, 'historywait')}>
                        {getLocaleWordContent('상품현황')} &gt;
                    </button>
                </div>
            </div>
        </>
    );
}
export default connect(
    (state) => ({
        show: state.widget.getIn(['message', 'show']),
    }),
    (dispatch) => ({
        ProductActions: bindActionCreators(productActions, dispatch),
        ModalActions: bindActionCreators(modalActions, dispatch),
    }),
)(Package);
